const shades = {
    white: '#ffffff',
    black: '#000000',
    background: '#fffefa',
    clear: 'transparent',
};
export default shades;
//# sourceMappingURL=shades.js.map